import React from 'react'
import { Button } from '@material-ui/core'
import { CreateAuthz } from '../../../Authz/containers/AuthzHocCreator'
import { COMPONENT_PERMS } from '../../../Authz/types'
import { actualizarDatosParaMuiTable } from './actions/MenuDeMuestrasTablaActions'
import { connect } from 'react-redux'
import { deleteMuestra } from '../../../../models/calado/menu_muestras_llamados'
import { COLORES } from '../../../../config/colores'

const ButtonModificiacion = CreateAuthz(COMPONENT_PERMS['/calado/muestras'], false, false)(Button)

function OperacionesMuestras (props) {
  const { numeroMuestra } = props
  function onClick () {
    deleteMuestra(numeroMuestra).then(() => {
      props.actualizarDatosParaMuiTable()
    })
  }
  return (
    <div>
      <ButtonModificiacion style={{ color: COLORES.red.medium }} onClick={onClick}>
          ELIMINAR
      </ButtonModificiacion>
    </div>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(OperacionesMuestras)
